const DISCOUNT_TYPE = {
    FIXED: 'fixed',
    PERCENT: 'percent'
};

export default {
    DISCOUNT_TYPE
};
